<template>
  <subscribe-widget
    v-if="uniqueCode && widgetData"
    ref="container"
    :unique-code="uniqueCode"
    :widget-data="widgetData"
    :completed="completed"
    @submit="submit"
  />
</template>

<script lang="ts">
import { getUniqueCode } from '@widgets/shared/compositions/uniqueCode'
import { sendWidgetAppearMessage, sendWidgetResizeMessage } from '@widgets/shared/utils/windowMessages'
import { useSubscribeForm } from '@widgets/subscribe/compositions/subscribeForm'
import { addPaddingsToBoundaries } from '@widgets/shared/utils/boundaries'
import SubscribeWidget from '@widgets/subscribe/components/SubscribeWidget.vue'
import { useQuasarIcons } from '@widgets/shared/compositions/quasarIcons'
import subscribeApiService from '@widgets/subscribe/services/subscribeApiService'
import { defineComponent, onBeforeUnmount, ref, watch } from '@/composition/vue/compositionApi'
import type { SubscribeWidgetData } from '@/services/domain/services/forms/subscribe/types'

export default defineComponent({
  components: {
    SubscribeWidget,
  },
  setup() {
    const container = ref()

    sendWidgetAppearMessage('static')

    useQuasarIcons()

    const uniqueCode = getUniqueCode()

    const widgetData = ref<SubscribeWidgetData>()
    subscribeApiService.getSettings(uniqueCode).then((settings) => {
      if (!settings) return
      widgetData.value = settings
      form.countryCode = settings.defaultCountryId
    })

    const { completed, submit, form } = useSubscribeForm(uniqueCode!, widgetData)

    const sendWidgetResizeMessageWithData = () => {
      if (!container.value || !widgetData.value) return

      const width = widgetData.value.width
      const height = container.value.$el.offsetHeight
      const boundaries = addPaddingsToBoundaries({ width, height }, {}, 10)
      sendWidgetResizeMessage(boundaries)
    }

    const resizeObserver = new ResizeObserver((_entries) => {
      requestAnimationFrame(() => {
        sendWidgetResizeMessageWithData()
      })
    })

    watch([container, widgetData], () => {
      if (!container.value) return
      sendWidgetResizeMessageWithData()
      resizeObserver.unobserve(container.value.$el)
      resizeObserver.observe(container.value.$el)
    })

    onBeforeUnmount(() => {
      resizeObserver.disconnect()
    })

    return {
      container,
      uniqueCode,
      widgetData,
      completed,
      submit,
    }
  },
})
</script>
